import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Box from 'ui-box';
import {
  Button,
  Card,
  Container,
  FormField,
  Grid,
  Heading,
  InputGroup,
  majorScale,
  PageContainer,
} from '../../npaper';
import { IUserSnapshotIn, useStores } from '../../stores';
import validateEmail from '../../utils/email-validator';

export const ProfilePage = () => {
  const intl = useIntl();
  const history = useHistory();
  const { authStore } = useStores();

  const { reset, register, errors, formState, handleSubmit } =
    useForm<IUserSnapshotIn>();

  useEffect(() => {
    if (authStore.me) {
      reset({
        first_name: authStore.me.first_name,
        last_name: authStore.me.last_name,
        email: authStore.me.email,
        phone: authStore.me.phone,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore]);

  const onSubmit = async (values: IUserSnapshotIn) => {
    try {
      await authStore.updateMe(values);

      history.length > 0 ? history.goBack() : history.push('/settings');
    } catch (err) {
      // TODO: Handle errors
    }
  };

  return (
    <PageContainer>
      <Container>
        <Button
          iconLeft="arrow-left"
          marginBottom={majorScale(2)}
          onClick={() =>
            history.length > 0 ? history.goBack() : history.push('/settings')
          }
        >
          Indstillinger
        </Button>

        <Grid>
          <Card className="col-span-12 md:col-span-12 lg:col-span-10 xl:col-span-8">
            <div className="dialog">
              <Box className="header">
                <Heading size={400}>Din profil</Heading>
              </Box>
              <Grid padding={majorScale(2)} paddingTop={majorScale(4)}>
                <FormField className="col-span-9" label="Navn" inline>
                  <InputGroup
                    placeholder="Fornavn"
                    name="first_name"
                    isInvalid={!!errors.first_name}
                    validationMessage={
                      errors.first_name && errors.first_name.message
                    }
                    ref={register({ required: 'Du skal skrive dit fornavn' })}
                  />
                  <InputGroup
                    placeholder="Efternavn"
                    name="last_name"
                    isInvalid={!!errors.last_name}
                    validationMessage={
                      errors.last_name && errors.last_name.message
                    }
                    ref={register({ required: 'Du skal skrive dit efternavn' })}
                  />
                </FormField>

                <FormField
                  className="col-span-9"
                  label="Kontaktoplysninger"
                  inline
                >
                  <InputGroup
                    placeholder="Email"
                    name="email"
                    isInvalid={!!errors.email}
                    validationMessage={errors.email && errors.email.message}
                    ref={register({
                      validate: (v: string) =>
                        (!validateEmail(v) &&
                          intl.formatMessage({
                            defaultMessage:
                              'Please provide a valid email address',
                          })) ||
                        true,
                      required: 'Du skal skrive din email',
                    })}
                  />
                  <InputGroup placeholder="Mobil" name="phone" ref={register} />
                </FormField>

                {/* TODO: Add avatar and preferences for email communication
              <FormField className="col-span-9" label="Avatar" inline center>
                <Box display="flex" alignItems="center">
                  <Card
                    width={majorScale(6)}
                    height={majorScale(6)}
                    backgroundColor="white"
                    marginRight={majorScale(1)}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon="person" color={defaultFills.muted} />
                  </Card>
                  <Button iconLeft="add" minimal>
                    Upload billede
                  </Button>
                </Box>
              </FormField>

              <FormField
                className="col-span-9"
                label="Email kommunikation"
                inline
              >
                <Checkbox label="Jeg ønsker at modtage vigtige notifikationer" />
                <Checkbox label="Jeg ønsker at modtage markedsføringsmateriale" />
              </FormField>*/}
              </Grid>
              <Box className="actions">
                <Button disabled={formState.isSubmitting}>Annuller</Button>
                <Button
                  primary
                  isLoading={formState.isSubmitting}
                  onClick={handleSubmit(onSubmit)}
                >
                  Gem ændringer
                </Button>
              </Box>
            </div>
          </Card>
        </Grid>
      </Container>
    </PageContainer>
  );
};
